module.exports = __webpack_public_path__ + "static/contact-64fb8a6c031e021a72de8ea970588908.svg";